var cs = {
	"neptune.Button.loadingAriaLabel": "načítání",
	"neptune.Chips.ariaLabel": "Vyčistit {choice}",
	"neptune.ClearButton.ariaLabel": "Vyčistit",
	"neptune.CloseButton.ariaLabel": "Zavřít",
	"neptune.DateInput.day.label": "Den",
	"neptune.DateInput.day.placeholder": "DD",
	"neptune.DateInput.month.label": "Měsíc",
	"neptune.DateInput.year.label": "Rok",
	"neptune.DateInput.year.placeholder": "RRRR",
	"neptune.DateLookup.day": "den",
	"neptune.DateLookup.goTo20YearView": "Go to 20 year view",
	"neptune.DateLookup.month": "měsíc",
	"neptune.DateLookup.next": "další",
	"neptune.DateLookup.previous": "předchozí",
	"neptune.DateLookup.selected": "vybráno",
	"neptune.DateLookup.twentyYears": "20 let",
	"neptune.DateLookup.year": "rok",
	"neptune.FlowNavigation.back": "back to previous step",
	"neptune.Info.ariaLabel": "Více informací",
	"neptune.Link.opensInNewTab": "(opens in new tab)",
	"neptune.MoneyInput.Select.placeholder": "Vybrat možnost...",
	"neptune.Select.searchPlaceholder": "Hledat...",
	"neptune.SelectInput.noResultsFound": "Nebyly nalezeny žádné výsledky",
	"neptune.Summary.statusDone": "Položka dokončena",
	"neptune.Summary.statusNotDone": "Položka k dokončení",
	"neptune.Summary.statusPending": "Čekající položka",
	"neptune.Upload.csButtonText": "Nahrát další soubor?",
	"neptune.Upload.csFailureText": "Nahrání se nezdařilo. Zkuste to prosím později",
	"neptune.Upload.csSuccessText": "Úspěšně nahráno!",
	"neptune.Upload.csTooLargeMessage": "Soubor musí být menší než {maxSize}MB",
	"neptune.Upload.csWrongTypeMessage": "Tento formát souboru není podporován. Zkuste to znovu s jiným souborem",
	"neptune.Upload.psButtonText": "Zrušit",
	"neptune.Upload.psProcessingText": "Načítání...",
	"neptune.Upload.usButtonText": "Nebo vyberte soubor",
	"neptune.Upload.usDropMessage": "Pusťte sem soubor pro jeho nahrání",
	"neptune.Upload.usPlaceholder": "Přetáhněte a pusťte sem soubor menší než {maxSize}MB",
	"neptune.UploadButton.allFileTypes": "Všechny typy souborů",
	"neptune.UploadButton.dropFiles": "Pusťte sem soubor pro jeho nahrání",
	"neptune.UploadButton.instructions": "{fileTypes}, menší než {size}MB",
	"neptune.UploadButton.uploadFile": "Nahrát soubor",
	"neptune.UploadButton.uploadFiles": "Nahrát soubory",
	"neptune.UploadInput.deleteModalBody": "Odstraněním tohoto souboru jej smažete z našeho systému.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Zrušit",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Odstranit",
	"neptune.UploadInput.deleteModalTitle": "Jistě chcete odstranit tento soubor?",
	"neptune.UploadInput.fileIsTooLarge": "Soubor je příliš velký",
	"neptune.UploadInput.fileTypeNotSupported": "Typ souboru není podporován",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Je nám líto, ale toto nahrání se nezdařilo, protože můžeme přijmout pouze {maxFilesAllowed} souborů najednou.",
	"neptune.UploadItem.deleting": "Mažeme...",
	"neptune.UploadItem.removeFile": "Odstranit soubor {filename}",
	"neptune.UploadItem.uploaded": "Nahráno",
	"neptune.UploadItem.uploadedFile": "Nahraný soubor",
	"neptune.UploadItem.uploading": "Nahrávání...",
	"neptune.UploadItem.uploadingFailed": "Nahrání se nezdařilo"
};

export { cs as default };
//# sourceMappingURL=cs.json.mjs.map
